module.exports = __webpack_public_path__ + "img/ClayZunfer.882cb245.jpg";